module.exports = __webpack_public_path__ + "static/media/calculatorC.a4e8faad.jpg";